/*
  Season gift card note — behaviour for snippets/cart-gift-note.liquid.
  Uses delegated listeners on document because the cart drawer markup is replaced via innerHTML
  on every cart update, so per-element bindings would be lost.
*/
(function () {
  var PERSONAL = 'Personal message';

  function getRoot(el) {
    return el.closest('[data-gift-note]');
  }

  function getOption(root) {
    var checked = root.querySelector('input[name="attributes[Gift note option]"]:checked');
    return checked ? checked.value : '';
  }

  function getValue(root, name) {
    var input = root.querySelector('[name="attributes[' + name + ']"]');
    return input ? input.value.trim().toLowerCase() : '';
  }

  function setOpen(root, open) {
    root.classList.toggle('is-open', open);
    root.querySelectorAll('[data-gift-note-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Personal fields are only meaningful for "Personal message"; blank values remove the attribute.
  function buildAttributes(root) {
    var option = getOption(root);
    var personal = option === PERSONAL;
    return {
      'Gift note option': option,
      'Gift note to': personal ? getValue(root, 'Gift note to') : '',
      'Gift note from': personal ? getValue(root, 'Gift note from') : '',
      'Gift note message': personal ? getValue(root, 'Gift note message') : ''
    };
  }

  // Mirror the saved state into any other rendered instance (cart page + drawer can both exist).
  function syncInstances(source, attributes) {
    document.querySelectorAll('[data-gift-note]').forEach(function (root) {
      root.classList.add('is-saved');
      if (root === source) return;
      root.querySelectorAll('input[name="attributes[Gift note option]"]').forEach(function (radio) {
        radio.checked = radio.value === attributes['Gift note option'];
      });
      ['Gift note to', 'Gift note from', 'Gift note message'].forEach(function (name) {
        var input = root.querySelector('[name="attributes[' + name + ']"]');
        if (input) input.value = attributes[name];
      });
      updateCount(root);
    });
  }

  function updateCount(root) {
    var textarea = root.querySelector('[data-gift-note-message]');
    var count = root.querySelector('[data-gift-note-count]');
    if (textarea && count) count.textContent = textarea.value.length;
  }

  function save(root, button) {
    var attributes = buildAttributes(root);

    if (!attributes['Gift note option']) {
      setOpen(root, false);
      return;
    }

    if (attributes['Gift note option'] === PERSONAL && !attributes['Gift note message']) {
      root.classList.add('has-error');
      root.querySelector('[data-gift-note-message]').focus();
      return;
    }

    button.setAttribute('disabled', true);
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        syncInstances(root, attributes);
        setOpen(root, false);
      })
      .catch(function () {
        alert('Sorry, we could not save your gift note. Please try again.');
      })
      .finally(function () {
        button.removeAttribute('disabled');
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-gift-note-toggle]');
    if (toggle) {
      var root = getRoot(toggle);
      setOpen(root, !root.classList.contains('is-open'));
      return;
    }

    var done = e.target.closest('[data-gift-note-done]');
    if (done) save(getRoot(done), done);
  });

  document.addEventListener('input', function (e) {
    var field = e.target.closest('[data-gift-note-text]');
    if (!field) return;

    // Cards are typewritten in lowercase — keep the stored value lowercase, preserving the caret.
    var start = field.selectionStart;
    var end = field.selectionEnd;
    var lower = field.value.toLowerCase();
    if (lower !== field.value) {
      field.value = lower;
      field.setSelectionRange(start, end);
    }

    var root = getRoot(field);
    root.classList.remove('has-error');
    updateCount(root);
  });

  // Checkout submits the cart form with the attributes[...] inputs. Clear the personal fields
  // first when another option is picked, so stale text doesn't reach the order.
  document.addEventListener('submit', function (e) {
    e.target.querySelectorAll('[data-gift-note]').forEach(function (root) {
      if (getOption(root) === PERSONAL) return;
      root.querySelectorAll('[data-gift-note-text]').forEach(function (field) {
        field.value = '';
      });
    });
  }, true);
})();
